import { Box, CssBaseline } from "@mui/material";

export default function Card({ children, sx, ...props }) {
  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "gray.light",
        flexDirection: "column",
        alignSelf: "stretch",
        p: "12px",
        gap: "10px",
        borderRadius: "4px",
        color: "#000",
        ...sx,
      }}
      {...props}
    >
      <CssBaseline />
      {children}
    </Box>
  );
}
